import React, { Component } from 'react';
import './editStory.scss';
import Footer from '../Footer/footer';
import Header from '../Header/header';

// import Services
import getStoryByID from '../../services/story/getStoryByID';
import editStory from '../../services/story/editStory';
import addCover from '../../services/addCover';
import toastNotify from '../../utils/toastNotifier';

import { LinkTypes, LinkTypesMapper } from '../../constants/constant';
import withRouter from '../withRouter';
import cookie from '../../cookieHelper/cookie';
import { auth as AuthObject } from '../../services/login';
import { Navigate } from 'react-router-dom';
import { validateLinkUrl } from '../../utils/validate';





class EditStory extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            linkUrl: '',
            linkType: 0,
            storyData: [],
            expiryDate: '',
            coverObj: '',
            currentPreview: '',
            imgSrc: '',
            tokencheck:true,
            publishOn: '', 
            linkText: ''

        }

        this.storyId = this.props.params.storyId;
        this.s3BaseUrl = process.env.REACT_APP_S3_URL;
        this.baseVideoPath = 'https://s3.ap-south-1.amazonaws.com/storiesmedia/';
    }

    fetchStoryById = async () => {
        try {
            const storyDetails = await getStoryByID(this.storyId);
    
            if (storyDetails.status.code === "10200") {
                if (storyDetails.data) {
                    this.setState({
                        storyData: storyDetails.data,
                        linkUrl: storyDetails.data[0].linkUrl,
                        linkType: parseInt(storyDetails.data[0].linkType, 10),
                        expiryDate: storyDetails.data[0].expiryDate,
                        publishOn: storyDetails.data[0].publishOn || '' ,
                        linkText: storyDetails.data[0].linkText || '',

                    });
                } else {
                    // Show no data toast message
                    console.log("No data available");
                }
            }
        } catch (error) {
    
            const response = error.response; // axios attaches the response object to the error
            const code = response?.data?.status?.code;
    
    
            if (code == 10411 || code == 10412 || code == 10416 || code == 10417) {

                this.setState({ tokencheck: false });
                cookie.delete_cookie(process.env.REACT_APP_COOKIE_NAME);
                cookie.delete_cookie('loginProfileInfo');
                AuthObject.isAuthenticated = false;


            }
    
            // Handle other errors
            console.error("Error occurred:", error);
        }
    };
    

    componentDidMount() {

        this.fetchStoryById();
    }

    setLinkType = (e, id) => {
        const linkType = parseInt(e.target.value, 10);
        const { publishOn } = this.state;
        const portal = publishOn && publishOn[0] ? publishOn[0] : 'iimjobs';
        
        // Default URLs based on portal
        const defaultUrls = {
            iimjobs: 'https://www.iimjobs.com/registration/addAudioVideoProfile',
            hirist: 'https://www.hirist.tech/registration/addAudioVideoProfile'
        };

        // If recruiter profile is selected (type 3), set the default URL

        if (linkType === 3) {
            this.setState({
                linkType,
                linkUrl: defaultUrls[portal] || defaultUrls.iimjobs
            });
        } else {
            this.setState({ linkType });
        }
    }

    setLinkUrl = (e, id) => {
        this.setState({
            linkUrl: e.target.value
        })
    }

    setExpiry = (e) => {
        this.setState({
            expiryDate: e.target.value
        })
    }

    setLinkText = (e, id) => {
        this.setState({
            linkText: e.target.value
        })
    }
    setCover = async (e, rowIndex) => {

        var form = new FormData();
        form.append('cover', document.getElementById("myfile_" + rowIndex).files[0]);

        var val = document.getElementById("myfile_" + rowIndex).files[0];
        console.log('val: ', val);

        let result = await addCover(form);
        this.setState({
            coverObj: result.data
        })

    }
    logoValidation = (index) => {
        var formData = new FormData();

        var file = document.getElementById("myfile_" + index).files[0];

        if (file) {
            formData.append("Filedata", file);
            // var t = file.type.split('/').pop().toLowerCase();
            if (file.size == 0) {
                toastNotify(3, 'Please select banner image');
                return false;
            }
            else if (file.size > 200000) {
                // alert('Max Upload size is 200KB only');
                toastNotify(3, 'Maximum upload size is 200KB only');
                document.getElementById("myfile_" + index).value = '';
                return false;
            }
            else {
                console.log("It can be uploaded");
                return true;
            }

        }
        else {
            // alert('No image Selected');
            toastNotify(3, 'Please select banner image');
            return false;
        }
    }
    onSubmit = async (e, rowIndex, fileType, bannerUrl) => {
        e.preventDefault();


        const data = {
            expiryDate: this.state.expiryDate
        }

        if (fileType == 2) {
            // var form = new FormData();
            // form.append("bannerUrl", document.getElementById("myfile_" + rowIndex).files[0]);
            // var val = document.getElementById("myfile_" + rowIndex).files[0];

            // console.log('val :', val);
            if (typeof this.state.coverObj == 'object') {
                data.bannerUrl = this.state.coverObj.coverRelativePath;
            }
            else {
                data.bannerUrl = bannerUrl;
            }

        }

        if (typeof this.state.linkUrl != 'undefined' && this.state.linkUrl.length) {
            data.linkUrl = this.state.linkUrl
        }

        if (typeof this.state.linkType != 'undefined' && this.state.linkType) {
            data.linkType = parseInt(this.state.linkType);
        }

        if (typeof this.state.linkText != 'undefined' && this.state.linkText.length) {
            data['linkText'] = this.state.linkText;
        }

        console.log('data: ', data);

        const { linkUrl = '', linkType, linkText = '' } = data;
        const { publishOn } = this.state; 

        const portal = publishOn[0];
        
        const isValidUrl = /^(https?:\/\/)?(www\.)?[\w.-]+\.[a-z]{2,}(\/\S*)?$/i.test(linkUrl);

        const externalDomainRegex = /(?:iimjobs\.com|hirist\.com|hirist\.tech)/i;
    
        if (linkUrl && !isValidUrl) {
            toastNotify(3, "Please enter a valid URL");
            return;
        }
    
        if (linkUrl && !linkText.length) {
            toastNotify(3, "Please add ‘Swipe Up Text’ to proceed");
            return;
        }

        if ( linkText && linkText.length > 60) {
            toastNotify(3, "Swipe Up Text should be less than 60 characters");
            return;
        }


        const validation = validateLinkUrl(linkUrl, linkType,portal);

        console.log("recruiterlinkdefault",validation);
        
        if (validation.defaultUrl) {
            // Set default URL for recruiter profile
            data.linkUrl = validation.defaultUrl;
            console.log("Setting default URL for recruiter profile");
        } else if (!validation.isValid) {
            // Handle other invalid cases
            console.log("Invalid URL", validation.message);
            toastNotify(3, validation.message);
            return;
        }
        
        var ans = true;
        if (fileType == 2) {
            var ans = this.logoValidation(rowIndex);
        }
        if (ans == true) {
            this.validateData(data, e);
        }
    }

    validateData = async (data, e) => {
        e.persist();
        if (data.expiryDate == '') {
            alert("Please fill expiry date.");
        }
       // Update this condition
        else if ((data.linkUrl && !data.linkType) || (!data.linkUrl && data.linkType && data.linkType !== 3)) {
            toastNotify(3, "Please fill both Link type and Link Url or none");
        }
        else {
            try {
                let result = await editStory(this.storyId, data);
                if (result?.status?.code == 10200) {
                    // e.target.parentElement.parentElement.classList.add("hidden");
                    toastNotify(1, "Successfully Edited story");
                    // alert("Successfully Edited story");
                }
                else{

                    const response = JSON.parse(result.request.response);
                    const code = response?.status?.code;
                    if (code == 10411 || code == 10412 || code == 10416 || code == 10417) {
                        this.setState({ tokencheck: false });
                        cookie.delete_cookie(process.env.REACT_APP_COOKIE_NAME);
                        cookie.delete_cookie('loginProfileInfo');
                        AuthObject.isAuthenticated = false;
                    }
                    
                }

                console.log("###1111")
            }
            catch (err) {
                console.log("###2");

                console.log(err);
                toastNotify(3, "Story couldn't be edited. Please try later");
                // alert("Story couldn't be edited. Please try later");
            }
        }
    }

    render() {

        if (!this.state.tokencheck) {
            return <Navigate to={'/'} />
        }

        let rows = null;
        if (this.state.storyData.length) {
            rows = (
                this.state.storyData.map((item, index) => {
                    let videoClassName, imageClassName;
                    console.log('item: ', item);
                    if (item.storyType == 1) {
                        videoClassName = "videoComponent hidden";
                        imageClassName = "imageComponent";
                    }
                    else if (item.storyType == 2) {
                        videoClassName = "videoComponent";
                        imageClassName = "imageComponent hidden";
                    }

                    return (
                        <tr key={index} rowindex={index} storytype={item.storyType}>
                            <td>
                                <div className={videoClassName}>
                                    <video width="200" height="200" controls loop>
                                        <source src={this.baseVideoPath + item.s3Path} type="video/mp4" />
                                    </video>
                                </div>
                                <div className={imageClassName}>
                                    <img src={this.s3BaseUrl + "/" + item.s3Path} />
                                </div>

                            </td>
                            <td>
                                <input type="date" name="expiry" defaultValue={item.expiryDate.split("T")[0]} onChange={(e) => this.setExpiry(e)} />
                            </td>
                            <td>
                                {item.publishOn && item.publishOn[0] === 'iimjobs' ? 'IIMJobs' : 
                                item.publishOn && item.publishOn[0] === 'hirist' ? 'Hirist' : 
                                'N/A'}
                            </td>

                            <td>
                                <select onChange={(e) => this.setLinkType(e, index)} defaultValue={item.linkType}>
                                    <option value="">Select Link Type</option>
                                    {Object.keys(LinkTypesMapper).map((key) => <option key={key} value={key}>{LinkTypesMapper[key]}</option>)}
                                </select>
                            </td>

                            <td>
                                <input 
                                    type="text" 
                                    name="linkUrl" 
                                    value={this.state.linkUrl || ''} 
                                    onChange={(e) => this.setLinkUrl(e, index)}
                                />
                            </td>

                            <td>
                                <input type="text" name="linkText" onChange={(e) => this.setLinkText(e, index)} defaultValue={item.linkText}></input>
                            </td>
                           



                            <td>
                                {item.storyType == 2 ?
                                    <img id="logo_img" src={typeof this.state.coverObj == 'object' ? this.s3BaseUrl + "/" + this.state.coverObj.coverRelativePath : this.s3BaseUrl + "/" + item.bannerUrl} /> : ''
                                }
                                {item.storyType == 2 ?
                                    <input type="file" onChange={(e) => this.setCover(e, index)} id={`myfile_${index}`} name="myfile" className="color_green" accept=".jpg, .jpeg, .JPG, .JPEG" title=" "></input>
                                    : ""}
                                {
                                    item.storyType == 2 ? <p>Image size should not greater than 200Kb</p> : ''
                                }
                            </td>
                            <td>
                                {
                                    item.storyType == 2 ? <button className="color_green btn-default" onClick={(e) => this.onSubmit(e, index, item.storyType, item.bannerUrl)} >
                                        Edit
                                        </button>
                                        :
                                        <button className="color_green btn-default" onClick={(e) => this.onSubmit(e, index, item.storyType)}>
                                            Edit
                                        </button>
                                }

                            </td>
                        </tr>
                    )
                })
            )
        }


        return (

            <div>
                <Header />

                <section className="listing_header">
                    <h1> Edit Story</h1>
                    <div className="wrapper">
                        <div className="wrapperTable">
                            <table border="1" className="mtb20 recruiter_listing" width="100%">
                                <tbody>
                                    <tr className="table-header">
                                        <th className="table_header">Story</th>
                                        <th className="table_header">Expiry Date</th>
                                        <th className="table_header">Published On</th>
                                        <th className="table_header">Link Type</th>
                                        <th className="table_header">Link Url</th>
                                        <th className="table_header">Swipe Up Text</th>
                                        <th className="table_header">Options</th>
                                        <th className="table_header">Actions </th>
                                    </tr>

                                    {rows}
                                </tbody>
                            </table>

                        </div>

                    </div>
                </section>

                <Footer />
            </div>

        );
    }
}




export default withRouter(EditStory);